import React, { Component, Fragment } from "react";
import classnames from "classnames";
import { TiWarningOutline } from "react-icons/ti";
import { push } from "react-router-redux";
import moment from "moment";
import _ from "i18n";

import * as api from "Api";
import { onSuccess, onError, dateFormat } from "Utils";
import {
  savePresentationEmailHistory,
  sendPresentationEmail,
  fetchEmailTextModels
} from "Thunks";

import {
  SvgIcon,
  ICONS,
  TrelloIcon,
  CalendarIcon,
  AttachmentIcon
} from "../Common/Icons";
import {
  setOrganizationListFilterConfigState,
  setOrganizationListFilterPresentations,
  setFilterRoleCollaborators
} from "actions";
import CollaboratorPresentationsFetching from "./CollaboratorPresentationsFetching";

import collaboratorApi from "../../services/CollaboratorServices";
import styles from "./CollaboratorSpace.local.scss";
import { MODEL_TEXT_EMAILING, TTP_DASHBOARD_URL } from "Config";
import ModalEmailling from "../FicheClient/ModalEmailling";

class CollaboratorPresentations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      keyWord: null,
      activated: null,
      mailError: null,
      preparedFilter: "all",
      notCompletedFilter: null,
      statistics: [],
      recipients: [],
      emailsData: [],
      presentations: [],
      emailTextModels: [],
      selectedPresentations: [],
      sendingEmail: false,
      fetchingEmailData: false,
      loadingEmailModels: false
    };
  }

  componentDidMount() {
    let { keyWord } = this.state;
    let { year, lng } = this.props;
    this.fetchCollaboratorPresentationsData(keyWord, year);
    this.fetchEmailTextModels(lng);
  }

  componentDidUpdate(prevProps, prevState) {
    const { year } = this.props;
    if (prevProps.year !== year) {
      this.fetchCollaboratorPresentationsData(null, year);
    }
  }

  fetchCollaboratorPresentationsData = (query, year) => {
    const { user, organization, synchro } = this.props;
    let stateTabs = "notPrepared";
    this.setState({ loading: true });
    collaboratorApi
      .getCollaboratorPresentations(
        organization.uen,
        user.id,
        year,
        query,
        synchro
      )
      .then(resp => {
        let response = resp.data.data;
        this.setState({
          statistics: response.statistics,
          presentations: response.presentations,
          loading: false
        });
        response.presentations.forEach(presentation => {
          if (presentation.isPrepared) {
            stateTabs = "prepared";
          }
        });
        this.handleSwitchStateTabs(stateTabs);
      })
      .catch(error => {
        this.setState({ error: true, loading: false });
      });
  };

  renderCollaboratorPresentationsHeader = () => {
    let { keyWord, statistics } = this.state;

    let presentationsCount =
      statistics.length > 0
        ? statistics[0].count + statistics[1].count + statistics[2].count
        : 0;

    return (
      <div className={styles.large_section_header}>
        <div className={styles.label}>
          <div>
            {_("Présentations")} ({presentationsCount})
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div className="search-box" style={{ width: 300 }}>
            <span className="search-box__icon">
              <img src="/img/icons/search.svg" alt="" />
            </span>
            <input
              value={keyWord ? keyWord : ""}
              style={{ width: 250 }}
              placeholder={`${_("search")} ..."`}
              onChange={event => this.handleSearcheByKeyWord(event)}
            />
          </div>
        </div>
      </div>
    );
  };

  renderCollaboratorPresentationsStatus = () => {
    let { statistics } = this.state;
    let { activated } = this.state;
    return (
      <div className={styles.large_section_statistics}>
        {statistics.map((statistic, i) => {
          return (
            <div
              key={i}
              className={classnames(
                "column medium-4",
                styles.frame,
                statistic.status === "prepared"
                  ? styles.succes
                  : statistic.status === "presented"
                    ? styles.default
                    : styles.danger
              )}
              onClick={() => this.handleSwitchStateTabs(statistic.status)}
            >
              <div className={styles.percentage_bar}>
                <div />
                <div style={{ width: `${statistic.percentage}%` }} />
              </div>
              <div
                className={classnames(
                  styles.content,
                  activated === statistic.status && styles.activated
                )}
              >
                <div>
                  <span>{_(statistic.status)}</span>
                  <div>
                    <TrelloIcon
                      fill={
                        statistic.status === "prepared"
                          ? "#02af8e"
                          : statistic.status === "presented"
                            ? "#6D7F92"
                            : "#F9626D"
                      }
                    />
                    <b>{statistic.count}</b>
                    <span>Prés.</span>
                  </div>
                </div>
                <div>{`${statistic.percentage}%`}</div>
              </div>
              {activated === statistic.status && (
                <Fragment>
                  <div className={styles.dot} />
                  <div className={styles.hidder} />
                </Fragment>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  renderCollaboratorPresentationsSubStatus = () => {
    let { preparedFilter, activated, notCompletedFilter } = this.state;
    return (
      activated === "prepared" && (
        <Fragment>
          <div className={styles.tabs}>
            {["all", "completed", "notCompleted"].map((type, i) => {
              return (
                <div
                  key={i}
                  className={
                    styles.tab_badge +
                    " " +
                    (preparedFilter === type ? styles.tab_badge_active : "")
                  }
                  onClick={() => this.handleSelectPreparedSubState(type)}
                >
                  {_(type)}
                </div>
              );
            })}
          </div>
          {preparedFilter === "notCompleted" && (
            <div className={styles.tabs}>
              {["undefinedDate", "noAnnexes"].map((type, i) => {
                return (
                  <div
                    key={i}
                    className={
                      styles.tab_tag +
                      " " +
                      (notCompletedFilter === type ? styles.tab_tag_active : "")
                    }
                    onClick={() => this.handleSelectNotCompletedState(type)}
                  >
                    {_(type)}
                  </div>
                );
              })}
            </div>
          )}
        </Fragment>
      )
    );
  };

  renderCollaboratorPresentationsItems = () => {
    let { selectedPresentations, loadingEmailModels, activated } = this.state;
    let { lng, year } = this.props;
    if (selectedPresentations.length === 0) {
      return (
        <div className={styles.empty_frame}>
          <div className={styles.cercle}>
            <TrelloIcon fill={"#B2BCC6"} size={26} />
          </div>
          <span>{_("noPresentations")}</span>
        </div>
      );
    }
    return (
      <div className={styles.large_section_items}>
        {selectedPresentations.map((presentation, k) => {
          const date = new Date(presentation.date);
          let formatedDate = date.toLocaleDateString("en-GB");
          return (
            <div key={k} className={styles.item}>
              {presentation.createdAt && (
                <span>
                  {_("createdAt")} {dateFormat(presentation.createdAt, lng)}
                </span>
              )}
              <div
                className={classnames(
                  styles.frame,
                  activated === "prepared"
                    ? styles.succes
                    : activated === "presented"
                      ? styles.default
                      : styles.danger
                )}
              >
                <div className="medium-6" style={{ display: "flex" }}>
                  <div className={styles.frame_miniature} />
                  <div className={styles.frame_details}>
                    <div className={styles.frame_details_title}>
                      {`${_("presentation")} ${presentation.clientName}`}
                    </div>
                    <div className={styles.frame_details_details}>
                      <TrelloIcon
                        fill={
                          activated === "prepared"
                            ? "#02af8e"
                            : activated === "presented"
                              ? "#6D7F92"
                              : "#F9626D"
                        }
                        size={12}
                      />
                      <span>
                        {_(
                          presentation.isPrepared ? "prepared" : "notPrepared"
                        )}
                      </span>
                    </div>
                    <div className={styles.frame_details_details}>
                      <CalendarIcon fill={"#6D7F92"} size={12} />
                      <span>
                        {_(
                          presentation.isPresented
                            ? "presentedThe"
                            : presentation.isPrepared
                              ? "toPresenteThe"
                              : ""
                        )}{" "}
                        {presentation.date ? formatedDate : _("undefinedDate")}
                      </span>
                    </div>
                    <div className={styles.frame_details_details}>
                      {presentation.annexe ? (
                        <AttachmentIcon fill={"#6D7F92"} size={12} />
                      ) : (
                        <TiWarningOutline />
                      )}
                      <span>
                        {_(presentation.annexe ? "withAnnexe" : "noAnnexes")}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="medium-2" style={{ marginLeft: "2%" }}>
                  <b>{presentation.clientName}</b>
                  <div className={styles.frame_number}>{presentation.uen}</div>
                  <div className={styles.frame_tags}>
                    {presentation.roles &&
                      presentation.roles.map(role => {
                        return <span key={`role-${role}`}>{role}</span>;
                      })}
                  </div>
                </div>
                <div className="medium-4">
                  <div className={styles.frame__actions}>
                    <div
                      onClick={() =>
                        this.handleRedirectToFicheClient(presentation.uen)
                      }
                    >
                      <SvgIcon icon={ICONS.CLIPBOARD} className={""} />
                    </div>
                    <div
                      onClick={() =>
                        this.handleRedirectToPlayPresentation(presentation.uen)
                      }
                    >
                      <SvgIcon icon={ICONS.PLAY} className={""} />
                    </div>
                    <div
                      onClick={() =>
                        this.handleRedirectToEditPresentation(presentation.uen)
                      }
                    >
                      <SvgIcon icon={ICONS.PENCIL} className={""} />
                    </div>
                    <div
                      className={
                        loadingEmailModels ? styles.action_disabled : ""
                      }
                      onClick={() => {
                        this.handleOpenEmailModal(year, presentation);
                      }}
                    >
                      <SvgIcon icon={ICONS.SEND} className={""} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  handleRedirectToEditPresentation = uen => {
    const { year } = this.props;
    this.props.dispatch(push(`/prepare-presentation/${uen}?year=${year}`));
  };

  handleRedirectToFicheClient = uen => {
    this.props.dispatch(push(`/fiche-client/${uen}/${this.props.year}`));
  };

  handleRedirectToPlayPresentation = uen => {
    const { year } = this.props;
    this.props.dispatch(push(`/diaporama/${uen}?year=${year}`));
  };

  // *********** start Presentation Email function ************* //
  fetchEmailTextModels = lng => {
    this.setState({ loadingEmailModels: true });
    this.props
      .dispatch(fetchEmailTextModels(lng))
      .then(res => {
        let contents = res.value.data.data.map(t => {
          return {
            type: t.targetType,
            content: t.content
          };
        });
        this.setState({
          emailTextModels: contents,
          loadingEmailModels: false
        });
      })
      .catch(er => {
        this.setState({
          mailError: 120000,
          loadingEmailModels: false
        });
      });
  };

  handleOpenEmailModal = (year, item) => {
    const { organization } = this.props;
    let { loadingEmailModels } = this.state;
    if (loadingEmailModels) {
      return;
    }
    this.setState({
      mailError: null,
      fetchingEmailData: true
    });
    Promise.all([
      api.getPresentationEmailHistory(item.uen, organization.uen, year),
      api.getAccessKey(item.uen, "ALL"),
      api.getEmailRecipients(item.uen)
    ])
      .then(([historyResponse, urlsResponse, recipientsResponse]) => {
        let newHistory = this.prepareHistoryMap(historyResponse.data.data, {});
        let recipients = recipientsResponse.data.data;
        let contents = urlsResponse.data.data.map(t => {
          return {
            expires: t.expires,
            period: t.period,
            target: t.target,
            key: t.key
          };
        });
        this.prepareDataEmailContentModal(year, item, contents);
        this.setState({
          history: newHistory,
          recipients,
          fetchingEmailData: false
        });
      })
      .catch(error => {
        this.setState({
          mailError:
            error.response.data.errors && error.response.data.errors[0].code,
          fetchingEmailData: false
        });
      });
    this.setState({ isEmailModalVisible: true });
  };

  prepareDataEmailContentModal(year, item, generatedURLs) {
    let { emailTextModels } = this.state;

    let generatedURLData = generatedURLs.filter(url => {
      return url.period === year + "";
    });
    let generatedUrl = generatedURLData.length
      ? TTP_DASHBOARD_URL +
        "/presentation/" +
        generatedURLData[0].target +
        "?year=" +
        year +
        "&&access_key=" +
        generatedURLData[0].key
      : null;

    let emailsDataArray = emailTextModels.map(model => {
      let disabled =
        (model.type === "APPOINTMENT" && item && !item.date) ||
        (model.type === "GENERATED_LINK" && !generatedURLData.length)
          ? true
          : false;
      return {
        modelCode: model.type,
        disabled: disabled,
        modelType: _(MODEL_TEXT_EMAILING[model.type].title),
        clientName: item.clientName,
        clientUen: item.uen,
        datePresentation: item && item.date ? item.date : null,
        textButton: _(MODEL_TEXT_EMAILING[model.type].action),
        description: model.content,
        state: item && item.isPrepared ? "prepared" : "notPrepared",
        url: generatedUrl,
        expires: generatedURLData.length && generatedURLData[0].expires,
        year
      };
    });
    this.setState({
      emailsData: emailsDataArray
    });
  }

  prepareHistoryMap = (histories, history) => {
    let result = history;
    histories.forEach(item => {
      if (!result[item.model]) {
        result[item.model] = [
          { date: item.sentThe, recipient: item.recipient }
        ];
      } else {
        result[item.model].unshift({
          date: item.sentThe,
          recipient: item.recipient
        });
      }
    });
    return result;
  };

  renderCollaboratorPresentationsModal = () => {
    let {
      lng,
      mailError,
      fetchingEmailData,
      sendingEmail,
      emailsData,
      recipients,
      history
    } = this.state;
    return (
      <ModalEmailling
        isVisible={this.state.isEmailModalVisible}
        onSendEmail={this.handleSendEmail}
        modelEmailing={emailsData}
        recipients={recipients}
        isClose={this.closeModal}
        error={mailError}
        lng={lng}
        history={history}
        sending={sendingEmail}
        fetching={fetchingEmailData}
        onRedirectHome={this.handleRedirectFolderSetting}
        onRedirectEmailing={this.handleRedirectEmailingSetting}
      />
    );
  };

  handleRedirectFolderSetting = () => {
    const { organization } = this.props;
    const { appsState } = this.props;
    let directoryConfig =
      appsState && appsState.filter(app => app.code === "directory")[0];

    window.open(
      `${directoryConfig.url}/folders/${organization.uen}/edit`,
      "_blank"
    );
  };

  handleRedirectEmailingSetting = () => {
    const { appsState } = this.props;
    let emailingConfig =
      appsState && appsState.filter(app => app.code === "emailing")[0];

    window.open(`${emailingConfig.url}/templates`, "_blank");
  };

  handleSendEmail = (recipient, modelCode, data, emails) => {
    const { lng } = this.props;
    this.setState({ sendingEmail: true });
    this.props
      .dispatch(sendPresentationEmail(recipient, modelCode, lng, data))
      .then(res => {
        this.handleSavePresentationMailHistory(modelCode, data, emails);
      })
      .catch(err => {
        onError(err.response.data.errors[0].message);
        this.setState({
          sendingEmail: false
        });
      });
  };

  handleSavePresentationMailHistory = (modelCode, data, emails) => {
    let { history, emailsData } = this.state;
    let target = emailsData[0].clientUen;
    this.setState({ sendingEmail: true });
    this.props
      .dispatch(
        savePresentationEmailHistory(
          target,
          emails,
          modelCode,
          data["{{PRESENTATION.YEAR}}"]
        )
      )
      .then(res => {
        onSuccess(res, {
          title: _("sendSuccess"),
          body: _("mailSent")
        });
        let element = [
          {
            model: modelCode,
            recipient: "[".concat("", emails.join(",")).concat("", "]"),
            sentThe: moment().format("YYYY-MM-DD HH:mm")
          }
        ];
        let newHistory = this.prepareHistoryMap(element, history);
        this.setState({ sendingEmail: false, history: newHistory });
      })
      .catch(err => {
        onError(err.response.data.errors[0].message);
        this.setState({
          sendingEmail: false
        });
      });
  };

  closeModal = () => {
    this.setState({ isEmailModalVisible: false });
  };
  // ********** end Presentation Email function *************** //

  handleSearcheByKeyWord = event => {
    let { loading } = this.state;
    let { year } = this.props;

    if (loading) {
      return;
    } else {
      this.setState({
        keyWord: event.target.value
      });
      if (event.target.value.length > 2 || event.target.value.length === 0) {
        this.fetchCollaboratorPresentationsData(event.target.value, year);
      }
    }
  };

  handleRedirectCollaboratorPresentations = () => {
    const { synchro, dispatch, user, year } = this.props;
    let { activated } = this.state;
    dispatch(setOrganizationListFilterConfigState(""));
    dispatch(setFilterRoleCollaborators(""));
    dispatch(
      setOrganizationListFilterPresentations(
        activated === "prepared"
          ? "PREPARED"
          : activated === "notPrepared"
            ? "NOT_PREPARED"
            : "PRESENTED"
      )
    );
    if (synchro) {
      dispatch(push(`/folders?collaboratorId=${user.id}&year=${year}`));
    } else {
      dispatch(push(`/folders?year=${year}`));
    }
  };

  handleSwitchStateTabs = status => {
    let { presentations } = this.state;
    let selectedPresentations = presentations.filter(
      presentation => presentation.status === status
    );
    this.setState({
      activated: status,
      selectedPresentations: selectedPresentations
    });
  };

  handleSelectPreparedSubState = state => {
    let { presentations } = this.state;
    let selectedPresentations = [];
    switch (state) {
      case "all":
        selectedPresentations = presentations.filter(
          presentation => presentation.status === "prepared"
        );
        break;
      case "notCompleted":
        selectedPresentations = presentations.filter(presentation => {
          return (
            presentation.status === "prepared" &&
            (!presentation.date || !presentation.annexe)
          );
        });
        break;
      case "completed":
        selectedPresentations = presentations.filter(presentation => {
          return (
            presentation.status === "prepared" &&
            presentation.date &&
            presentation.annexe
          );
        });
        break;
      default:
        selectedPresentations = [];
    }
    this.setState({
      selectedPresentations: selectedPresentations,
      preparedFilter: state,
      notCompletedFilter: null
    });
  };

  handleSelectNotCompletedState = state => {
    let { presentations } = this.state;
    let selectedPresentations = [];
    switch (state) {
      case "noAnnexes":
        selectedPresentations = presentations.filter(
          presentation =>
            presentation.status === "prepared" && !presentation.annexe
        );
        break;
      case "undefinedDate":
        selectedPresentations = presentations.filter(
          presentation =>
            presentation.status === "prepared" && !presentation.date
        );
        break;
      default:
        selectedPresentations = [];
    }
    this.setState({
      selectedPresentations: selectedPresentations,
      notCompletedFilter: state
    });
  };

  renderCollaboratorPresentationsFooter = () => {
    let { selectedPresentations } = this.state;
    if (selectedPresentations.length > 0) {
      return (
        <div className={styles.large_section_footer}>
          <div
            className={styles.button}
            onClick={() => this.handleRedirectCollaboratorPresentations()}
          >
            <span>{_("seeAll")}</span>
          </div>
        </div>
      );
    }
  };

  render() {
    let { loading, error } = this.state;
    return (
      <div className={styles.large_section}>
        {this.renderCollaboratorPresentationsHeader()}
        {loading ? (
          <CollaboratorPresentationsFetching />
        ) : error ? (
          <div className={styles.empty_frame}>
            <TiWarningOutline />
            <span>{_("oops")}</span>
          </div>
        ) : (
          <Fragment>
            {this.renderCollaboratorPresentationsStatus()}
            {this.renderCollaboratorPresentationsSubStatus()}
            {this.renderCollaboratorPresentationsItems()}
            {this.renderCollaboratorPresentationsFooter()}
            {this.renderCollaboratorPresentationsModal()}
          </Fragment>
        )}
      </div>
    );
  }
}

export default CollaboratorPresentations;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorPresentations.js